import React from "react"
import { connect } from "react-redux"
import * as actionCreators from "../redux/action_creators"
import OnboardingSection from "../components/onboarding/onboarding_section"
import { appStrings } from "../common/strings/app_strings"
import {
    validateFields,
    parseTextAreaToFields,
    removeEmptyFields,
    generateDefaultInviteFields,
} from "../util/onboarding_utils"
import { alerts } from "../util/alert_error_utils"
import { makeToast } from "../util/toast_util"
import { SettingsFormField } from "../components/settings/settings_form_field"
import { InviteTeamMembers } from "../components/invite_team_members"

const { msg } = alerts.validEmailRequired

const {
    inviteYourTeamTitle,
    inviteYourTeamButton,
    optional,
    companyLabel,
    howWould,
    withMyTeamButton,
    forPersonal,
} = appStrings.onboarding

const initialState = {
    companyName: "",
    fields: generateDefaultInviteFields(1),
    isTextArea: false,
    textAreaContent: "",
    showOptions: true,
    showComponent: false,
}

class InviteYourTeam extends React.Component {
    constructor(props) {
        super(props)

        this.state = initialState

        this.textInput = null
        this.setTextInputRef = element => (this.textInput = element)
        this.focusTextInput = () => {
            if (this.textInput) this.textInput.focus()
        }
    }

    componentWillMount() {
        this.handleAccountProps()
    }

    componentDidUpdate({ accounts }) {
        // handles account settings if they did not ingress before component mounting
        if (this.props.accounts.sort != accounts.sort) {
            this.handleAccountProps()
        }
    }

    handleAccountProps = () => {
        const account = this.props.accounts.items[this.props.profile.accountId]
        if (!account) {
            return
        }
        const { tier } = account
        // if tier is personal, do not show "invite your team" component, skip this page
        // if tier is team, do not show invite your team component
        // if tier is not set, show options
        if (tier === "personal") {
            this.skipTeam()
            return
        }
        if (tier === "team") {
            this.setState({ showOptions: false })
        }
        this.setState({ showComponent: true })
    }

    handleTextAreaChange = value => {
        const updatedTextAreaContent = value

        this.setState({ textAreaContent: updatedTextAreaContent })
    }

    handleNavigateAndPatch = e => {
        const { fields, isTextArea, textAreaContent } = this.state

        // check if the user has clicked "Skip for later"
        if (e.target.id === "skip") {
            this.skipTeam()
            // if the user clicks continue
        } else {
            const textFields = isTextArea
                ? parseTextAreaToFields(textAreaContent, false)
                : removeEmptyFields(fields)
            if (validateFields(textFields)) {
                const { companyName } = this.state
                const patchMeta = { fields: textFields, companyName }

                return this.props.handleNavigateAndPatch(
                    patchMeta,
                    this.props.history,
                )
            } else {
                if (isTextArea) {
                    this.setState({ fields: textFields })
                }

                return makeToast(msg, "danger")
            }
        }
    }

    handleTextAreaChange = value => {
        const newTextAreaContent = value
        this.setState({ textAreaContent: newTextAreaContent })
    }

    handleCompanyNameChange = value => {
        const companyName = value
        this.setState({ companyName })
    }
    
    updateState = (key, value, fn) => {
        this.setState({ [key]: value }, () => fn)
    }

    skipTeam = () => {
        this.props.handleNavigateAndPatch({}, this.props.history)
    }

    showOptions = () => (
        <div className="option-container">
            <div className="option-row">
                <div className="title-container">
                    <h3 className="option-title">{howWould}</h3>
                </div>
                <div className="option-btn-container-outer">
                    <div className="option-btn-container">
                        <button
                            className="btn btn-primary btn-use-options"
                            tabIndex="1"
                            onClick={() => this.setState({ showOptions: false })}
                        >
                            {withMyTeamButton}
                        </button>
                        <button
                            className="btn btn-primary btn-use-options"
                            tabIndex="2"
                            onClick={this.skipTeam}
                        >
                            {forPersonal}
                        </button>
                    </div>
                </div>
            </div>
        </div>
    )

    showTeamInvites = () => {
        const { isTextArea, companyName, fields, textAreaContent } = this.state
        return (
            <OnboardingSection
                sectionTitle={companyLabel}
                buttonValue={inviteYourTeamButton}
                onClickAction={this.handleNavigateAndPatch}
                hasSkipButton={true}
                isWide={true}
                extraBottomPadding={true}
            >
                <div className="row">
                    <div className="col-md-12 form-group">
                        <SettingsFormField
                            focus={true}
                            id="company-name" 
                            placeholder={optional}
                            value={companyName}
                            onChangeAction={this.handleCompanyNameChange}
                        />
                    </div>
                </div>
                <h4 className="invite-team-title">{inviteYourTeamTitle}</h4>
                <InviteTeamMembers
                    fields={fields}
                    textAreaContent={textAreaContent}
                    handleTextAreaChange={this.handleTextAreaChange}
                    isTextArea={isTextArea}
                    updateState={this.updateState}
                />
            </OnboardingSection>
        )
    }

    render() {
        const { showOptions, showComponent } = this.state
        if (!showComponent) {
            return <div />
        }
        return !showComponent ? (
            <div />
        ) : showOptions ? (
            this.showOptions()
        ) : (
            this.showTeamInvites()
        )
    }
}

function mapStateToProps(state) {
    return state
}
export default connect(
    mapStateToProps,
    actionCreators,
)(InviteYourTeam)



// WEBPACK FOOTER //
// ./src/pages/invite_your_team.jsx